















  import axios from 'axios'
  import ProjectCard from '@/components/ProjectCard.vue'
  import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    ProjectCard
  }
})
  export default class ProjectList extends Vue {
  projects: object[] = []
  errors: object[] = []

  async created () {
    try {
      const response = await axios.get('/projects.json')
      this.projects = response.data.projects
    } catch (e) {
      this.errors.push(e)
    }
  }
  }
